import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { MoveableSubAccountDispatcher, TransferRequestStore } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dictionary } from "../../../../react-core/Helpers/CommonHelper";
import { getQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { TransferSourceAccounts } from "../../../../Wrap/Models/Domains/Transfer/TransferSourceAccounts";
import { TransferSourceAccountsCollectionModel } from "../../../../Wrap/Models/Domains/Transfer/TransferSourceAccountsCollectionModel";

export interface MoveableSubAccountStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: TransferSourceAccountsCollectionModel;
}

export class MoveableSubAccountStoreStatic extends BaseStore<MoveableSubAccountStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(MoveableSubAccountDispatcher, (actionData) =>
            this.onMoveableSubAccountStoreResponse(actionData)
        );
    }

    public getLastResult(): MoveableSubAccountStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getAccounts() {
        return this.getState().data.SourceAccounts;
    }

    public getCurrentAccount() {
        const id = getQueryParameters()["hierarchyid"] || TransferRequestStore.getTransferRequest().SourceHierarchyId;
        const filterObj = this.getState().data.SourceAccounts.filter((ele) => ele.HierarchyId === id);
        if (filterObj.length > 0) {return filterObj[0];}
        return null;
    }

    public getOptions() {
        return this.getState().data.SourceAccounts.map((account) => {
            return account.HierarchyId;
        });
    }

    public getOptionsMap() {
        const options: Dictionary[] = [];
        this.getState().data.SourceAccounts.forEach((acc) => {
            options.push({ key: acc.HierarchyId, value: `${acc.ProductDisplayName} ${acc.ClAccountId}` });
        });
        return options;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): MoveableSubAccountStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onMoveableSubAccountStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
